import React from "react";

const CashieringImage = () => (
  <svg
    width="184"
    height="170"
    viewBox="0 0 184 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Illustration - Cashiering">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H184V170H4C1.79086 170 0 168.209 0 166V4Z"
        fill="#D9DAF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.199 56.0061C139.863 55.8523 138.016 53.9088 138.016 51.5338C138.016 49.0584 140.022 47.0517 142.498 47.0517C143.349 47.0517 144.145 47.289 144.823 47.701C145.586 44.9154 148.135 42.8684 151.163 42.8684C154.602 42.8684 157.424 45.509 157.713 48.8732C158.321 48.4771 159.048 48.2469 159.829 48.2469C161.974 48.2469 163.713 49.986 163.713 52.1314C163.713 54.2767 161.974 56.0159 159.829 56.0159C159.728 56.0159 159.628 56.012 159.53 56.0045V56.0159H151.163H142.498H142.199V56.0061Z"
        fill="#A99DD2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.665 100.837C24.3448 100.837 23.2746 99.7666 23.2746 98.4464C23.2746 97.1262 24.3448 96.0559 25.665 96.0559C26.0359 96.0559 26.387 96.1404 26.7002 96.2911C27.2253 95.4332 28.1711 94.8607 29.2507 94.8607C30.5805 94.8607 31.7073 95.7294 32.0949 96.9302C32.4013 96.7542 32.7565 96.6536 33.1352 96.6536C34.2903 96.6536 35.2268 97.59 35.2268 98.7452C35.2268 99.9004 34.2903 100.837 33.1352 100.837H29.2507H25.665Z"
        fill="#A99DD2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.2106 47.6495H57.3381H53.0893V47.6395C53.0124 47.6461 52.9346 47.6495 52.856 47.6495C51.3708 47.6495 50.1668 46.4455 50.1668 44.9603C50.1668 43.475 51.3708 42.271 52.856 42.271C53.0131 42.271 53.1669 42.2845 53.3166 42.3103C53.8181 40.5622 55.4287 39.283 57.3381 39.283C59.1174 39.283 60.6372 40.3938 61.2419 41.9598C61.4198 41.8851 61.6152 41.8439 61.8202 41.8439C62.3449 41.8439 62.8065 42.1141 63.073 42.5228C63.4185 42.3613 63.804 42.271 64.2106 42.271C65.6959 42.271 66.8999 43.475 66.8999 44.9603C66.8999 46.3669 65.8199 47.5213 64.4439 47.6395V47.6495H64.2106Z"
        fill="#A99DD2"
      />
      <path
        d="M110.526 126.832C110.526 128.978 102.365 130.717 92.2984 130.717C82.2319 130.717 74.0713 128.978 74.0713 126.832C74.0713 124.687 82.2319 122.948 92.2984 122.948C102.365 122.948 110.526 124.687 110.526 126.832Z"
        fill="#A99DD2"
      />
      <path
        d="M53.7525 69.7614H130.844V115.777C130.844 116.438 130.309 116.973 129.649 116.973H54.9478C54.2877 116.973 53.7525 116.438 53.7525 115.777V69.7614Z"
        fill="white"
      />
      <path
        d="M51.9599 61.1257C51.9599 59.2941 53.4448 57.8092 55.2764 57.8092H129.321C131.153 57.8092 132.637 59.2941 132.637 61.1257V69.7614H51.9599V61.1257Z"
        fill="#E5E7EC"
      />
      <path
        d="M66.3021 63.7838C66.3021 64.4432 65.767 64.9777 65.1069 64.9777C64.4468 64.9777 63.9117 64.4432 63.9117 63.7838C63.9117 63.1244 64.4468 62.5898 65.1069 62.5898C65.767 62.5898 66.3021 63.1244 66.3021 63.7838Z"
        fill="#292A33"
      />
      <path
        d="M62.7165 63.7838C62.7165 64.4432 62.1814 64.9777 61.5213 64.9777C60.8612 64.9777 60.3261 64.4432 60.3261 63.7838C60.3261 63.1244 60.8612 62.5898 61.5213 62.5898C62.1814 62.5898 62.7165 63.1244 62.7165 63.7838Z"
        fill="#292A33"
      />
      <path
        d="M59.1309 63.7838C59.1309 64.4432 58.5958 64.9777 57.9357 64.9777C57.2756 64.9777 56.7405 64.4432 56.7405 63.7838C56.7405 63.1244 57.2756 62.5898 57.9357 62.5898C58.5958 62.5898 59.1309 63.1244 59.1309 63.7838Z"
        fill="#292A33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.649 59.602H54.948C54.2879 59.602 53.7527 60.1372 53.7527 60.7973V115.778C53.7527 116.438 54.2879 116.973 54.948 116.973H129.649C130.309 116.973 130.845 116.438 130.845 115.778V60.7973C130.845 60.1372 130.309 59.602 129.649 59.602ZM54.948 57.8092C53.2977 57.8092 51.9599 59.147 51.9599 60.7973V115.778C51.9599 117.428 53.2977 118.766 54.948 118.766H129.649C131.3 118.766 132.637 117.428 132.637 115.778V60.7973C132.637 59.147 131.3 57.8092 129.649 57.8092H54.948Z"
        fill="#292A33"
      />
      <path
        d="M156.542 111.595C156.542 110.935 157.077 110.399 157.737 110.399H167.896C168.557 110.399 169.092 110.935 169.092 111.595C169.092 112.255 168.557 112.79 167.896 112.79H157.737C157.077 112.79 156.542 112.255 156.542 111.595Z"
        fill="#292A33"
      />
      <path
        d="M132.637 110.399H152.243C152.908 110.399 153.448 110.939 153.448 111.605C153.448 112.27 152.908 112.81 152.243 112.81H132.637V110.399Z"
        fill="#292A33"
      />
      <path
        d="M35.2261 111.595C35.2261 110.935 35.7612 110.399 36.4213 110.399H51.9592V112.79H36.4213C35.7612 112.79 35.2261 112.255 35.2261 111.595Z"
        fill="#292A33"
      />
      <path
        d="M25.0673 111.595C25.0673 110.935 25.6024 110.399 26.2625 110.399H31.0434C31.7035 110.399 32.2386 110.935 32.2386 111.595C32.2386 112.255 31.7035 112.79 31.0434 112.79H26.2625C25.6024 112.79 25.0673 112.255 25.0673 111.595Z"
        fill="#292A33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.263 85.4553C100.228 85.4553 99.4816 86.0571 99.2985 86.7006C99.1846 87.101 98.7676 87.3333 98.3672 87.2193C97.9668 87.1054 97.7346 86.6884 97.8486 86.2881C98.2508 84.8743 99.6905 83.9478 101.263 83.9478C102.835 83.9478 104.275 84.8743 104.677 86.2881C104.791 86.6884 104.559 87.1054 104.158 87.2193C103.758 87.3333 103.341 87.101 103.227 86.7006C103.044 86.0571 102.298 85.4553 101.263 85.4553Z"
        fill="#292A33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.5299 85.4553C83.495 85.4553 82.7487 86.0571 82.5656 86.7006C82.4517 87.101 82.0347 87.3333 81.6343 87.2193C81.2339 87.1054 81.0017 86.6884 81.1156 86.2881C81.5179 84.8743 82.9576 83.9478 84.5299 83.9478C86.1022 83.9478 87.5418 84.8743 87.9441 86.2881C88.058 86.6884 87.8258 87.1054 87.4254 87.2193C87.025 87.3333 86.6081 87.101 86.4941 86.7006C86.311 86.0571 85.5647 85.4553 84.5299 85.4553Z"
        fill="#292A33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.4261 95.9004C85.8424 95.9004 86.1799 96.2379 86.1799 96.6541C86.1799 97.5581 86.9127 98.2908 87.8166 98.2908H96.7807C97.6847 98.2908 98.4174 97.5581 98.4174 96.6541C98.4174 96.2379 98.7549 95.9004 99.1712 95.9004C99.5875 95.9004 99.9249 96.2379 99.9249 96.6541C99.9249 98.3906 98.5172 99.7984 96.7807 99.7984H87.8166C86.0801 99.7984 84.6724 98.3906 84.6724 96.6541C84.6724 96.2379 85.0098 95.9004 85.4261 95.9004Z"
        fill="#292A33"
      />
      <path
        d="M51.9599 67.9678H132.637V69.7606H51.9599V67.9678Z"
        fill="#292A33"
      />
      <path
        d="M27.4588 72.7489C27.4588 72.0888 27.9939 71.5537 28.654 71.5537H51.9609V79.3227H28.654C27.9939 79.3227 27.4588 78.7875 27.4588 78.1274V72.7489Z"
        fill="#8F8CF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.9796 75.1566C30.655 75.0823 30.5754 75.035 30.5754 74.9269V74.9202C30.5754 74.8323 30.6516 74.768 30.8073 74.768C30.9922 74.768 31.1985 74.831 31.3925 74.957C31.4288 74.9805 31.4766 74.9725 31.5015 74.9367L31.7337 74.6021C31.7584 74.5665 31.7517 74.5163 31.7169 74.491C31.5734 74.3862 31.4116 74.312 31.2276 74.2687V74.0223C31.2276 73.979 31.1932 73.944 31.1508 73.944H30.684C30.6416 73.944 30.6073 73.979 30.6073 74.0223V74.242C30.1804 74.3142 29.9261 74.6021 29.9261 74.9809V74.9877C29.9261 75.4709 30.3071 75.6128 30.8007 75.7277C31.1188 75.8054 31.195 75.8562 31.195 75.9574V75.9643C31.195 76.0656 31.1022 76.1264 30.9266 76.1264C30.6806 76.1264 30.4486 76.0441 30.233 75.8872C30.1991 75.8626 30.152 75.87 30.1254 75.9026L29.8677 76.2165C29.8396 76.2507 29.8432 76.3026 29.8776 76.3303C30.0846 76.4969 30.3362 76.6022 30.6073 76.6463V76.8601C30.6073 76.8998 30.6389 76.932 30.6778 76.932H31.1571C31.196 76.932 31.2276 76.8998 31.2276 76.8601V76.6334C31.6054 76.5421 31.841 76.2829 31.841 75.9V75.8934C31.841 75.4506 31.5097 75.2748 30.9796 75.1566Z"
        fill="#FEFEFE"
      />
      <path
        d="M44.7901 75.4388C44.7901 74.9437 45.1915 74.5424 45.6865 74.5424H51.9615V76.3352H45.6865C45.1915 76.3352 44.7901 75.9339 44.7901 75.4388Z"
        fill="#FEFEFE"
      />
      <path
        d="M34.63 75.4388C34.63 74.9437 35.0313 74.5424 35.5264 74.5424H41.5025C41.9976 74.5424 42.399 74.9437 42.399 75.4388C42.399 75.9339 41.9976 76.3352 41.5025 76.3352H35.5264C35.0313 76.3352 34.63 75.9339 34.63 75.4388Z"
        fill="#FEFEFE"
      />
      <path
        d="M11.92 79.323C11.92 78.6629 12.4551 78.1278 13.1152 78.1278H59.1313C59.7914 78.1278 60.3265 78.6629 60.3265 79.323V84.7015C60.3265 85.3616 59.7914 85.8968 59.1313 85.8968H13.1152C12.4551 85.8968 11.92 85.3616 11.92 84.7015V79.323Z"
        fill="#B4B3F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4408 81.7307C15.1162 81.6564 15.0366 81.6091 15.0366 81.5009V81.4943C15.0366 81.4064 15.1128 81.3421 15.2685 81.3421C15.4534 81.3421 15.6597 81.4051 15.8537 81.5311C15.89 81.5546 15.9378 81.5466 15.9626 81.5108L16.1949 81.1762C16.2196 81.1406 16.2129 81.0904 16.1781 81.0651C16.0346 80.9603 15.8728 80.8861 15.6888 80.8428V80.5963C15.6888 80.5531 15.6544 80.5181 15.612 80.5181H15.1452C15.1028 80.5181 15.0685 80.5531 15.0685 80.5963V80.8161C14.6416 80.8883 14.3873 81.1762 14.3873 81.555V81.5618C14.3873 82.045 14.7682 82.1869 15.2619 82.3018C15.5799 82.3795 15.6562 82.4303 15.6562 82.5315V82.5384C15.6562 82.6397 15.5634 82.7005 15.3878 82.7005C15.1418 82.7005 14.9097 82.6182 14.6941 82.4613C14.6602 82.4367 14.6132 82.4441 14.5865 82.4767L14.3288 82.7906C14.3008 82.8248 14.3044 82.8767 14.3388 82.9044C14.5458 83.0709 14.7974 83.1763 15.0685 83.2204V83.4342C15.0685 83.4739 15.1 83.5061 15.139 83.5061H15.6182C15.6572 83.5061 15.6888 83.4739 15.6888 83.4342V83.2075C16.0666 83.1162 16.3022 82.857 16.3022 82.4741V82.4675C16.3022 82.0247 15.9709 81.8489 15.4408 81.7307Z"
        fill="#FEFEFE"
      />
      <path
        d="M45.9838 82.0129C45.9838 81.5178 46.3851 81.1165 46.8802 81.1165H56.442C56.937 81.1165 57.3384 81.5178 57.3384 82.0129C57.3384 82.5079 56.937 82.9093 56.442 82.9093H46.8802C46.3851 82.9093 45.9838 82.5079 45.9838 82.0129Z"
        fill="#FEFEFE"
      />
      <path
        d="M31.0439 82.0129C31.0439 81.5178 31.4452 81.1165 31.9403 81.1165H42.6973C43.1924 81.1165 43.5937 81.5178 43.5937 82.0129C43.5937 82.5079 43.1924 82.9093 42.6973 82.9093H31.9403C31.4452 82.9093 31.0439 82.5079 31.0439 82.0129Z"
        fill="#FEFEFE"
      />
      <path
        d="M19.0912 82.0129C19.0912 81.5178 19.4925 81.1165 19.9876 81.1165H27.7566C28.2516 81.1165 28.653 81.5178 28.653 82.0129C28.653 82.5079 28.2516 82.9093 27.7566 82.9093H19.9876C19.4925 82.9093 19.0912 82.5079 19.0912 82.0129Z"
        fill="#FEFEFE"
      />
      <path
        d="M132.637 65.5775H166.104C166.764 65.5775 167.299 66.1126 167.299 66.7727V72.1512C167.299 72.8113 166.764 73.3465 166.104 73.3465H132.637V65.5775Z"
        fill="#8F8CF0"
      />
      <path
        d="M156.543 69.4598C156.543 68.9647 156.944 68.5634 157.439 68.5634H163.415C163.91 68.5634 164.311 68.9647 164.311 69.4598C164.311 69.9548 163.91 70.3562 163.415 70.3562H157.439C156.944 70.3562 156.543 69.9548 156.543 69.4598Z"
        fill="#FEFEFE"
      />
      <path
        d="M145.785 69.4598C145.785 68.9647 146.187 68.5634 146.682 68.5634H153.255C153.751 68.5634 154.152 68.9647 154.152 69.4598C154.152 69.9548 153.751 70.3562 153.255 70.3562H146.682C146.187 70.3562 145.785 69.9548 145.785 69.4598Z"
        fill="#FEFEFE"
      />
      <path
        d="M132.638 68.5634H142.499C142.994 68.5634 143.395 68.9647 143.395 69.4598C143.395 69.9548 142.994 70.3562 142.499 70.3562H132.638V68.5634Z"
        fill="#FEFEFE"
      />
      <path
        d="M123.673 73.3468C123.673 72.6867 124.209 72.1516 124.869 72.1516H170.885C171.545 72.1516 172.08 72.6867 172.08 73.3468V78.7253C172.08 79.3854 171.545 79.9206 170.885 79.9206H124.869C124.209 79.9206 123.673 79.3854 123.673 78.7253V73.3468Z"
        fill="#B4B3F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M127.194 75.7546C126.87 75.6803 126.79 75.6331 126.79 75.5249V75.5182C126.79 75.4303 126.866 75.366 127.022 75.366C127.207 75.366 127.413 75.429 127.607 75.555C127.643 75.5785 127.691 75.5705 127.716 75.5347L127.948 75.2001C127.973 75.1645 127.966 75.1144 127.932 75.089C127.788 74.9842 127.626 74.91 127.442 74.8667V74.6203C127.442 74.5771 127.408 74.542 127.365 74.542H126.899C126.856 74.542 126.822 74.5771 126.822 74.6203V74.84C126.395 74.9123 126.141 75.2001 126.141 75.5789V75.5857C126.141 76.0689 126.522 76.2109 127.015 76.3257C127.333 76.4034 127.41 76.4542 127.41 76.5555V76.5623C127.41 76.6636 127.317 76.7244 127.141 76.7244C126.895 76.7244 126.663 76.6422 126.448 76.4853C126.414 76.4606 126.367 76.4681 126.34 76.5006L126.082 76.8145C126.054 76.8487 126.058 76.9007 126.092 76.9283C126.299 77.0949 126.551 77.2002 126.822 77.2444V77.4581C126.822 77.4978 126.854 77.53 126.892 77.53H127.372C127.411 77.53 127.442 77.4978 127.442 77.4581V77.2314C127.82 77.1401 128.056 76.8809 128.056 76.498V76.4914C128.056 76.0486 127.724 75.8729 127.194 75.7546Z"
        fill="#FEFEFE"
      />
      <path
        d="M158.335 76.0339C158.335 75.5388 158.736 75.1375 159.231 75.1375H168.195C168.691 75.1375 169.092 75.5388 169.092 76.0339C169.092 76.5289 168.691 76.9303 168.195 76.9303H159.231C158.736 76.9303 158.335 76.5289 158.335 76.0339Z"
        fill="#FEFEFE"
      />
      <path
        d="M143.394 76.0347C143.394 75.5396 143.796 75.1383 144.291 75.1383H155.048C155.543 75.1383 155.944 75.5396 155.944 76.0347C155.944 76.5298 155.543 76.9311 155.048 76.9311H144.291C143.796 76.9311 143.394 76.5298 143.394 76.0347Z"
        fill="#FEFEFE"
      />
      <path
        d="M130.845 76.0339C130.845 75.5388 131.246 75.1375 131.741 75.1375H140.108C140.603 75.1375 141.004 75.5388 141.004 76.0339C141.004 76.5289 140.603 76.9303 140.108 76.9303H131.741C131.246 76.9303 130.845 76.5289 130.845 76.0339Z"
        fill="#FEFEFE"
      />
      <path
        d="M88.4139 124.741V118.765H90.8043V126.227C90.8043 126.726 90.3994 127.131 89.8998 127.131H84.8282C84.1681 127.131 83.633 126.596 83.633 125.936C83.633 125.276 84.1681 124.741 84.8282 124.741H88.4139Z"
        fill="#404064"
      />
      <path
        d="M93.7927 126.227V118.765H96.1832V124.741H99.7688C100.429 124.741 100.964 125.276 100.964 125.936C100.964 126.596 100.429 127.131 99.7688 127.131H94.6972C94.1977 127.131 93.7927 126.726 93.7927 126.227Z"
        fill="#404064"
      />
      <path
        d="M132.637 99.0425V102.031L140.204 106.354C140.676 106.624 141.271 106.545 141.655 106.16L151.761 96.0544H148.175L140.871 103.651C140.774 103.752 140.62 103.773 140.5 103.702L132.637 99.0425Z"
        fill="#6145F7"
      />
      <path
        d="M145.187 94.8594C145.187 94.1993 145.722 93.6642 146.382 93.6642H155.944C156.604 93.6642 157.139 94.1993 157.139 94.8594C157.139 95.5195 156.604 96.0546 155.944 96.0546H146.382C145.722 96.0546 145.187 95.5195 145.187 94.8594Z"
        fill="#6145F7"
      />
      <path
        d="M51.9593 102.031V99.0426L41.5712 106.957C40.7439 107.588 41.0607 108.901 42.0844 109.084L62.7163 112.788V110.397L44.7879 107.409L51.9593 102.031Z"
        fill="#6145F7"
      />
      <path
        d="M65.7042 107.409H66.8995C67.5596 107.409 68.0947 107.944 68.0947 108.604C68.0947 109.265 67.5596 109.8 66.8995 109.8H66.3018C65.3117 109.8 64.509 110.602 64.509 111.592C64.509 112.583 65.3117 113.385 66.3018 113.385H68.6923C69.3524 113.385 69.8875 113.92 69.8875 114.581C69.8875 115.241 69.3524 115.776 68.6923 115.776H65.7042C63.7239 115.776 62.1186 114.17 62.1186 112.19V110.995C62.1186 109.015 63.7239 107.409 65.7042 107.409Z"
        fill="#6145F7"
      />
      <path
        d="M140.406 84.1037C140.406 81.7933 142.279 79.9204 144.59 79.9204H157.737C160.048 79.9204 161.921 81.7933 161.921 84.1037V90.0798C161.921 90.7399 161.385 91.275 160.725 91.275H141.602C140.942 91.275 140.406 90.7399 140.406 90.0798V84.1037Z"
        fill="#E5E7EC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.737 81.1156H144.59C142.94 81.1156 141.602 82.4534 141.602 84.1037V90.0798H160.725V84.1037C160.725 82.4534 159.387 81.1156 157.737 81.1156ZM144.59 79.9204C142.279 79.9204 140.406 81.7933 140.406 84.1037V90.0798C140.406 90.7399 140.942 91.275 141.602 91.275H160.725C161.385 91.275 161.921 90.7399 161.921 90.0798V84.1037C161.921 81.7933 160.048 79.9204 157.737 79.9204H144.59Z"
        fill="#292A33"
      />
      <path
        d="M143.992 84.1035C143.992 83.7734 144.259 83.5059 144.589 83.5059H157.737C158.067 83.5059 158.334 83.7734 158.334 84.1035C158.334 84.4335 158.067 84.7011 157.737 84.7011H144.589C144.259 84.7011 143.992 84.4335 143.992 84.1035Z"
        fill="#292A33"
      />
      <path
        d="M145.188 73.9442V84.7012H157.14V76.9322H160.128C160.458 76.9322 160.725 76.6647 160.725 76.3346V73.9442C160.725 72.6239 159.655 71.5537 158.335 71.5537H147.578C146.258 71.5537 145.188 72.6239 145.188 73.9442Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.14 76.9322H160.128C160.458 76.9322 160.725 76.6647 160.725 76.3346V73.9442C160.725 72.6239 159.655 71.5537 158.335 71.5537H147.578C146.258 71.5537 145.188 72.6239 145.188 73.9442V84.7012H157.14V76.9322ZM155.945 83.5059V75.737H159.53V73.9442C159.53 73.2841 158.995 72.7489 158.335 72.7489H147.578C146.918 72.7489 146.383 73.2841 146.383 73.9442V83.5059H155.945Z"
        fill="#292A33"
      />
      <path
        d="M155.944 73.9442C155.944 72.6239 157.015 71.5537 158.335 71.5537L-nan -nanL158.335 71.5537C159.655 71.5537 160.725 72.6239 160.725 73.9442V76.3346C160.725 76.6647 160.458 76.9322 160.128 76.9322H155.944V73.9442Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.53 75.737V73.9442C159.53 73.2841 158.995 72.7489 158.335 72.7489C157.675 72.7489 157.14 73.2841 157.14 73.9442V75.737H159.53ZM158.335 71.5537C157.015 71.5537 155.944 72.6239 155.944 73.9442V76.9322H160.128C160.458 76.9322 160.725 76.6647 160.725 76.3346V73.9442C160.725 72.6239 159.655 71.5537 158.335 71.5537Z"
        fill="#292A33"
      />
      <path
        d="M148.175 75.4378C148.175 75.2728 148.309 75.139 148.474 75.139H153.853C154.018 75.139 154.151 75.2728 154.151 75.4378V76.0355C154.151 76.2005 154.018 76.3343 153.853 76.3343H148.474C148.309 76.3343 148.175 76.2005 148.175 76.0355V75.4378Z"
        fill="#292A33"
      />
      <path
        d="M148.175 77.8281C148.175 77.6631 148.309 77.5293 148.474 77.5293H152.657C152.822 77.5293 152.956 77.6631 152.956 77.8281V78.4257C152.956 78.5907 152.822 78.7245 152.657 78.7245H148.474C148.309 78.7245 148.175 78.5907 148.175 78.4257V77.8281Z"
        fill="#292A33"
      />
      <path
        d="M148.175 80.2192C148.175 80.0542 148.309 79.9204 148.474 79.9204H153.853C154.018 79.9204 154.151 80.0542 154.151 80.2192V80.8168C154.151 80.9819 154.018 81.1156 153.853 81.1156H148.474C148.309 81.1156 148.175 80.9819 148.175 80.8168V80.2192Z"
        fill="#292A33"
      />
    </g>
  </svg>
);

export default CashieringImage;
